import { core } from '@icc/shared/helpers';
import { IWindowConfiguration } from '../window-configuration';
import { DoorConfiguration } from '../door-configuration';

export function changesInVersion25(
    oldConfiguration: any,
): IWindowConfiguration {
    const configuration: IWindowConfiguration = {
        ...core.copy(oldConfiguration),
    };

    if (configuration.type === 'door') {
        const conf = configuration as DoorConfiguration;
        const doorHardware = conf.doorHardware;
        if (doorHardware) {
            conf.doorHardware = {
                ...doorHardware,
                colorIsDefault: doorHardware.colorIsDefault ?? true,
                pullColorIsDefault: doorHardware.pullColorIsDefault ?? true,
                electronicLock: doorHardware.electronicLock ? {
                    ...doorHardware.electronicLock,
                    colorIsDefault: doorHardware.electronicLock.colorIsDefault ?? true,
                } : doorHardware.electronicLock,
                plates: doorHardware.plates ? {
                    ...doorHardware.plates,
                    colorIsDefault: doorHardware.plates.colorIsDefault ?? true,
                } : doorHardware.plates,
                outerPlates: doorHardware.outerPlates ? {
                    ...doorHardware.outerPlates,
                    colorIsDefault: doorHardware.outerPlates.colorIsDefault ?? true,
                } : doorHardware.outerPlates,
                cylinders: doorHardware.cylinders ? {
                    ...doorHardware.cylinders,
                    mainLockColorIsDefault: doorHardware.cylinders.mainLockColorIsDefault ?? true,
                    additionalLockColorIsDefault: doorHardware.cylinders.additionalLockColorIsDefault ?? true,
                } : doorHardware.cylinders,
            };
        }
    }

    return configuration;
}
